// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2wV48","header":"Messages_header__aHH6Y"};